import React from "react";
import { XCircle, CheckCircle, ArrowRight } from "@phosphor-icons/react";

const problems = [
  "Hónapokig tart az építkezés, csúszik a befejezés.",
  "Kőműves, anyagbeszerzés, egyeztetés — örökös káosz.",
  "Kiszámíthatatlan végösszeg: mindig drágább lesz.",
  "Fix méretű típusgarázsok, nem illenek a telekre.",
];
const solutions = [
  "Szerződéskötéstől számítva 1 hónapon belül kész. Fix naptári dátum.",
  "Egy csapat, egy felelős, egy szerződés.",
  "Fix vállalási ár. Meglepetés nélkül.",
  "Milliméterre egyedi méret, saját üzemünkben gyártva.",
];

export default function ProblemSolution() {
  return (
    <section id="problem-solution" data-testid="problem-solution-section" className="py-20 md:py-32 bg-[#F5F5F5]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="badge-chip" style={{ background: "#0F0F0F", color: "#FFFFFF" }}>
            A valóság
          </span>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tight mt-4 leading-[0.95]">
            Miért szenved mindenki a garázsépítéssel?
          </h2>
          <p className="text-[#525252] text-base md:text-lg mt-4 max-w-2xl">
            Mert a régi módszer lassú, drága és kiszámíthatatlan. Nálunk ez máshogy megy.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-0 border border-[#E4E4E7]">
          <div data-testid="problem-column" className="p-8 md:p-10 bg-[#FFFFFF] border-b md:border-b-0 md:border-r border-[#E4E4E7]">
            <div className="inline-flex items-center gap-2 mb-6">
              <XCircle size={28} weight="fill" className="text-[#A33A2D]" />
              <h3 className="font-display font-bold text-2xl text-[#0F0F0F]">Hagyományos építés</h3>
            </div>
            <ul className="space-y-5">
              {problems.map((p, i) => (
                <li key={i} className="flex gap-3">
                  <div className="w-6 h-6 border border-[#E4E4E7] flex items-center justify-center mt-0.5 shrink-0">
                    <XCircle size={14} weight="bold" className="text-[#525252]" />
                  </div>
                  <span className="text-[#0F0F0F] leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div data-testid="solution-column" className="p-8 md:p-10 bg-[#0F0F0F] text-[#FFFFFF]">
            <div className="inline-flex items-center gap-2 mb-6">
              <CheckCircle size={28} weight="fill" className="text-[#FFFFFF]" />
              <h3 className="font-display font-bold text-2xl">Rapidgarázs</h3>
            </div>
            <ul className="space-y-5">
              {solutions.map((p, i) => (
                <li key={i} className="flex gap-3">
                  <div className="w-6 h-6 bg-[#FFFFFF] flex items-center justify-center mt-0.5 shrink-0">
                    <CheckCircle size={14} weight="fill" className="text-[#0F0F0F]" />
                  </div>
                  <span className="text-[#E4E4E7] leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
            <a href="#configurator" data-testid="ps-cta" className="cta-light mt-8">
              Tervezze meg most <ArrowRight size={18} weight="bold" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
